export default __webpack_public_path__ + "static/4-d17eaebb14e989c9ba686fd87304a03d.png";